import { Tabs } from '@inflearn/ds-react';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';

import { MY_URL } from '../../../../../constants/urls';
import { useCurrentUrl } from '../../../../../hooks/useCurrentUrl';

export function SettingsPageTabs() {
  const { t } = useTranslation();
  const { currentUrlWithoutQueryString } = useCurrentUrl();

  return (
    <Tabs value={currentUrlWithoutQueryString} wrap="nowrap" radius="xs" mb={20}>
      <Tabs.List>
        <Tabs.Tab component={Link} href={MY_URL.ACCOUNT()} value={MY_URL.ACCOUNT()}>
          {t('계정 정보')}
        </Tabs.Tab>
        <Tabs.Tab component={Link} href={MY_URL.NOTIFICATION()} value={MY_URL.NOTIFICATION()}>
          {t('알림 설정')}
        </Tabs.Tab>
        <Tabs.Tab component={Link} href={MY_URL.DEVICE()} value={MY_URL.DEVICE()}>
          {t('마이페이지_기기관리_타이틀')}
        </Tabs.Tab>
      </Tabs.List>
    </Tabs>
  );
}
